import React from "react";
import { registrarError } from "../utils/errores";
import { colors, buttonStyle } from "../styles/theme";

// Atrapa errores de render de React (los que tumban toda la pantalla en
// blanco) para que la app muestre algo útil en vez de quedarse muerta, y de
// paso los manda a la bitácora de Historial → Errores.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { conError: false };
  }

  static getDerivedStateFromError() {
    return { conError: true };
  }

  componentDidCatch(error, info) {
    registrarError({
      mensaje: error?.message || String(error),
      stack: (error?.stack || "") + "\n" + (info?.componentStack || ""),
      tipo: "render",
      usuario: this.props.usuario
    });
  }

  render() {
    if (this.state.conError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: colors.paper, padding: "20px" }}>
          <div style={{ background: colors.surface, border: `1px solid ${colors.line}`, borderRadius: "12px", padding: "32px", maxWidth: "380px", textAlign: "center" }}>
            <p style={{ fontSize: "15px", color: colors.ink, margin: "0 0 8px", fontWeight: "600" }}>Algo salió mal</p>
            <p style={{ fontSize: "13px", color: colors.inkSoft, margin: "0 0 20px" }}>
              Ya quedó registrado. Intenta recargar la página.
            </p>
            <button style={buttonStyle("primary")} onClick={() => window.location.reload()}>Recargar</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
